import React, { useEffect, useState } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import './scss/style.scss'
import globalFunctions from './functions/GlobalFunctions';
import CookieFunctions from './functions/CookieFunctions';
import AppRoutes from './AppRoutes';
import RouteFilter from './functions/RouteFilter';
import Login from './pages/Login';
import Home from './pages/home';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

export default function App() {
    const nav = useNavigate();
    const loc = useLocation();
    const [filteredRoutes, setFilteredRoutes] = useState([]);

    // Filter routes based on Isaac mode
    useEffect(() => {
        const filtered = RouteFilter.filterRoutesByDevice(AppRoutes);
        setFilteredRoutes(filtered);
    }, [loc.search]); // Re-filter when URL parameters change

    // function to check if the route requires auth
    function requiresAuth(value) {
        for (let i = 0; i < filteredRoutes.length; i++) {
            const obj = filteredRoutes[i];
            if (obj["path"] === value) {
                if (obj["requireAuth"] === true) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return false;
    }

    //checks every route change if they are authenticated. redirects to login if not 
    useEffect(() => {
        const isIsaacMode = sessionStorage.getItem('isaacMode') === 'true';
        if (!globalFunctions.checkAuthenticated() && requiresAuth(loc.pathname) && loc.pathname !== '/login') {

            CookieFunctions.logout()
            
            // Redirect to login with Isaac parameter if in Isaac mode
            nav(isIsaacMode ? "/login?isaac=true" : "/login")
        } else if (globalFunctions.checkAuthenticated()) {
            // Redirect Isaac users away from home page to maintenance form

            const isDriver = CookieFunctions.getRole() === 'driver';
            
            if (isIsaacMode && isDriver && (loc.pathname === '/' || loc.pathname === '/home')) {
                nav('/maintenance/form');
                return;
            }

            const myHeaders = new Headers();
            myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

            const data = new FormData();
            data.append('route', loc.pathname);

            fetch(`api/User/track`, {
                method: 'POST',
                headers: myHeaders,
                body: data
            })
        }
    }, [nav, filteredRoutes, loc.pathname])

    function routes() {
        if (globalFunctions.checkAuthenticated()) {
            return (
                // Authenticated routes
                <DefaultLayout>
                    <Routes>
                        {filteredRoutes.map((route, index) => {
                            const { element, requireAuth, ...rest } = route;
                            return (requireAuth && 
                                (route.roles ? route.roles.includes(CookieFunctions.getRole()) : true) && 
                                (route.driverType ? route.driverType.includes(CookieFunctions.getDriverType()) : true) && 
                                (route.country ? route.country.includes(CookieFunctions.getCountry()) : true) && 
                                (route.status ? route.status.includes(CookieFunctions.getStatus()) : true)) && 
                                <Route key={index} {...rest} element={element} />;
                        })}
                        <Route path="*" element={<Home />} />
                    </Routes>
                </DefaultLayout>

            );
        } else {
            return (
                // Unauthenticated routes
                <Routes>
                    {filteredRoutes.map((route, index) => {
                        const { element, requireAuth, ...rest } = route;
                        return !requireAuth && <Route key={index} {...rest} element={element} />;
                    })}
                    <Route path="*" element={<Login />} />
                </Routes>
            )
        }
    }

    return (
        <>
            <ToastContainer
                hideProgressBar={true}
                closeOnClick
                autoClose={10000}
                pauseOnHover
            />
            <AuthenticatedTemplate>
                {routes()}
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                {routes()}
            </UnauthenticatedTemplate>
        </>
    )

}